export enum CouponType {
  OFFER_TYPE_SITE_WIDE_AMOUNT = 'sitewide amount',
  OFFER_TYPE_SITE_WIDE_PERCENT = 'sitewide percent',
  OFFER_TYPE_FREE_SHIPPING = 'free shipping',
  OFFER_TYPE_SALE_AMOUNT = 'sale amount',
  OFFER_TYPE_SALE_PERCENT = 'sale percent',
  OFFER_TYPE_FREE_PRODUCT = 'Free Product',
  OFFER_TYPE_OTHER = 'Other',
}

export const CouponOffers: {[index: string]: string[]} = {}
CouponOffers[CouponType.OFFER_TYPE_OTHER] = ['', 'Sale', '', '']
CouponOffers[CouponType.OFFER_TYPE_SALE_PERCENT] = ['', 'Sale', '', 'sale']
CouponOffers[CouponType.OFFER_TYPE_SALE_AMOUNT] = ['', 'Sale', '', 'sale']
CouponOffers[CouponType.OFFER_TYPE_SITE_WIDE_AMOUNT] = ['', 'Sale', '', 'sale']
CouponOffers[CouponType.OFFER_TYPE_SITE_WIDE_PERCENT] = ['', 'Sale', '', 'sale']
CouponOffers[CouponType.OFFER_TYPE_FREE_SHIPPING] = [
  '',
  'Free Shipping',
  '',
  'free-shipping',
]
CouponOffers[CouponType.OFFER_TYPE_FREE_PRODUCT] = [
  '',
  'Freebie',
  '',
  'freebie',
]
